<template>
  <div class="modal-window">
    <h1>Dodaj swój pierwszy profil!</h1>
    <p>By móc rozpocząć swoją przygodę z automatyzacją, musisz przypisać swojemu
      kontu FollowUP przynajmniej jeden profil. By to zrobić, kliknij przycisk poniżej,
      a następnie wypełnij formularz.</p>
    <button @click="showModal('AddProfileModal')">Dodaj profil</button>
  </div>
</template>

<script>
export default {
  name: 'AddFirstProfileDialog',
  methods: {
    showModal(componentName) {
      this.$store.commit("showModal", componentName);
    }
  }
};
</script>
